import { apiClient } from '@copro/api';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { enqueueSnackbar } from '../../../components/GlobalSnackbar/snackbarStore';
import { useSpace } from '../../../hooks/useSpace';
import { keys } from './keys';

async function deleteExpense(expenseId: string) {
  const { error } = await apiClient
    .from('expenses')
    .delete()
    .eq('id', expenseId);

  if (error) {
    throw error;
  }
}

export function useDeleteExpense() {
  const queryClient = useQueryClient();
  const { currentSpace } = useSpace();

  return useMutation({
    mutationFn: deleteExpense,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: keys.expenses(currentSpace!.id) });
      enqueueSnackbar('Dépense supprimée.', 'success');
    },
  });
}
